import LeaOverviewPage from './LeaOverviewPage.vue'
import LeaOverviewSidebar from './LeaOverviewSidebar.vue'

const OverviewArea = {
  LeaOverviewPage,
  LeaOverviewSidebar
}

export { OverviewArea }
